import React from "react";
import { Link } from "react-router-dom";
import { useContent } from "../contexts/SiteContentContext";

export default function Footer() {
  const f = useContent("footer");
  const g = useContent("global");
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/10 bg-ink-50 mt-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <img
            src={g.logo_url || "https://customer-assets.emergentagent.com/job_dossier-mystery/artifacts/vt3uyove_3749EAEB-3526-46E9-8579-0CBF7804F1AF.png"}
            alt={g.brand_full || "CrimesEmCasa"}
            className="h-16 w-auto object-contain mb-6"
          />
          <p className="text-bone-muted text-sm leading-relaxed max-w-md">
            {f.description || "Mistérios para resolver em casa."}
          </p>
          <p className="mono text-[10px] text-bone-faded mt-8 tracking-[0.3em]">
            {f.classification || "CLASSIFICAÇÃO: ACESSO PÚBLICO"}
          </p>
        </div>

        <div>
          <p className="section-tag mb-5">Investigação</p>
          <ul className="space-y-3">
            <li>
              <Link to="/casos" className="text-sm text-bone-dim hover:text-blood transition-colors">
                Todos os Casos
              </Link>
            </li>
            <li>
              <Link to="/como-funciona" className="text-sm text-bone-dim hover:text-blood transition-colors">
                Como Funciona
              </Link>
            </li>
            <li>
              <Link to="/loja" className="text-sm text-bone-dim hover:text-blood transition-colors">
                Loja
              </Link>
            </li>
            <li>
              <Link to="/contacto" className="text-sm text-bone-dim hover:text-blood transition-colors">
                Contacto
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <p className="section-tag mb-5">Contacto</p>
          <ul className="space-y-3 text-sm text-bone-dim">
            <li>{f.contact_email || "geral@crimesemcasa.pt"}</li>
            <li>{f.contact_location || "Lisboa · Portugal"}</li>
            <li className="mono text-[10px] text-bone-faded mt-6">
              {(f.ref_prefix || "REF: PRJ-CEC-")}{new Date().getFullYear()}
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="mono text-[10px] text-bone-faded tracking-[0.3em]">
            © {new Date().getFullYear()} {(g.brand_full || "CRIMESEMCASA").toUpperCase()} — {(f.copyright || "TODOS OS DIREITOS RESERVADOS")}
          </p>
          <p className="mono text-[10px] text-bone-faded tracking-[0.3em]">
            {f.footer_tagline || "CASO ENCERRADO // ACESSO AUTORIZADO"}
          </p>
        </div>
      </div>
    </footer>
  );
}
